export enum ChartDisplayType {
  NONE = 'none',
  STACKED_BAR = 'stacked-bar',
  BAR = 'bar',
  LINE = 'line',
  SCATTER = 'scatter',
  DOUGHNUT = 'doughnut',
  MIXED = 'mixed'
}

export enum ChartDataType {
  DATE = 'date',
  STRING = 'string',
  STRING_BAR_SCATTER = 'string-bar-scatter',
  NUMBER_PREDICTION = 'number-prediction'
}

export interface ChartBase {
  title: string;
  type: ChartDataType;
  id: string;
  tooltipFormat: Intl.NumberFormat;
  shouldShowChartTypeDropdown: boolean;
  defaultChartDisplayType: ChartDisplayType;
}

export interface AxisChart extends ChartBase {
  yAxisFormat: Intl.NumberFormat;
  xAxisTitle: string;
  yAxisTitle: string;
}

export interface ChartByString extends ChartBase {
  dataPointSets: DataPointSetByString[];
  shouldAnimate: boolean;
}

export interface AxisChartByDate extends AxisChart {
  dataPointSets: DataPointSetByDate[];
  shouldShowDateRangeDropdown: boolean;
}

export interface AxisChartByString extends AxisChart {
  dataPointSets: DataPointSetByString[];
  yHighestValue?: number;
  shouldAnimate: boolean;
}

export interface ChartByStringBarScatter extends AxisChart {
  barDataPointSets: DataPointSetByString[];
  scatterDataPointSets: DataPointSetByStringYAxis[];
  yHighestValue: number;
  yScatterHighestValue: number;
}

export interface AxisChartByNumberPrediction extends AxisChart {
  dataPointSetWithPredictions: DataPointSetByNumberPrediction[];
  dataPointSetWithOptimisations: DataPointSetByNumberOptimisation[];
}

export interface DataPointSet {
  label: string;
  value: number;
}

export interface DataPointSetByDate {
  dataPointDate: string;
  countByDate: number;
  dataPointSetName: string;
}

export interface DataPointSetByString {
  dataPointString: string;
  value: number;
  dataPointSetName: string;
}

export interface DataPointSetByStringYAxis {
  dataPointString: string;
  value: number;
  dataPointSetName: string;
  yAxisName: string;
  yAxisFormat: Intl.NumberFormat;
  yAxisTooltipFormat: Intl.NumberFormat;
  yAxisTitle: string;
}

export interface DataPointSetByNumberOptimisation {
  xValue: number;
  yValue: number;
  dataPointSetName: string;
}
export interface DataPointSetByNumberPrediction {
  xValue: number | null;
  yValue: number | null;
  dataPointSetName: string;
  actualParentDataPointSetName: string;
  style: DataPointSetStyle;
}
export enum DataPointSetStyle {
  SOLID = 'solid',
  DASHED = 'dashed'
}
